const DARK_PALETTE = 'dark';

export default function isDarkTheme({ palette }) {
    return (palette.mode || palette.type) === DARK_PALETTE;
}
